import { Store, Module, ActionContext } from 'vuex'
import ListModule from './list-module'
import ListState from './list-state'
import EmployeeJobDiaryItem from '../entities/employee-job/employee-job-diary'
import Ajax from '../../lib/ajax'
import PageResult from '@/store/entities/page-result';
import appconst from './../../lib/appconst';
interface EmployeeJobDiaryState extends ListState<EmployeeJobDiaryItem> {
    viewJob:any;
}
class EmployeeJobDiaryModule extends ListModule<EmployeeJobDiaryState, any, EmployeeJobDiaryItem>{
    state = {
        totalCount: 0,
        currentPage: 1,
        pageSize: 10,
        list: new Array<EmployeeJobDiaryItem>(),
        loading: false
    }
    actions = {
        async getAll(context: ActionContext<EmployeeJobDiaryState, any>, payload: any) {
            context.state.loading = true;
            const {data:{result} }= await Ajax.get('/api/services/app/report/EmployeeJobDiary', { params: payload.data });
            context.state.loading = false;
            const page = result as PageResult<EmployeeJobDiaryItem>;
            context.state.totalCount = page.totalCount;
            context.state.list = page.items;
        },
        async getWorkOrderTypeForSelect(context: ActionContext<EmployeeJobDiaryState, any>, payload: any) {
            const {data:{result} } = await Ajax.get('/api/services/app/report/GetWorkOrderTypeForSelect',{ params: payload.data });
            return result.items;
        },
        async exportEmployeeJobDiary(context:ActionContext<EmployeeJobDiaryState,any>,payload:any){
            var url = `${appconst.remoteServiceBaseUrl}report/ExportEmployeeJobDiary${abp.utils.buildQueryString(Object.keys(payload.data).map((key) => {
                return {
                    name: key,
                    value: payload.data[key]
                }
            }), true)}`;
            window.open(url, "_blank");    
        },
    };
    mutations = {
        setCurrentPage(state: EmployeeJobDiaryState, page: number) {
            state.currentPage = page;
        },
        setPageSize(state: EmployeeJobDiaryState, pagesize: number) {
            state.pageSize = pagesize;
        },
        view(state:EmployeeJobDiaryState,job:any){
            state.viewJob=job;
        }
    }
}
const employeeJobDiaryModule = new EmployeeJobDiaryModule();
export default employeeJobDiaryModule;